/**
 *
 */

(function( window, undefined ) {

    var FrontEndProperties = function (config) {
        if (!(this instanceof FrontEndProperties)) {
            return new FrontEndProperties(config);
        }

        var fe = this;

        fe.init = function () {
            fe.loaded = false;
            var promise = createPromise();
            var configPromise = loadConfig(config);

            function processInit() {
                fe.loaded = true;
                promise.setSuccess();
            }

            configPromise.success(processInit);
            configPromise.error(function () {
                promise.setError();
            });

            return promise.promise;
        };

        /**
         *
         * @param url
         * @returns {promise}
         */
        function loadConfig(url) {
            var promise = createPromise();
            var configUrl;

            if (!config) {
                configUrl = 'frontend-properties.json';
            } else if (typeof config === 'string') {
                configUrl = config;
            }

            var req = new XMLHttpRequest();
            req.open('GET', configUrl, true);
            req.setRequestHeader('Accept', 'application/json');

            req.onreadystatechange = function () {
                if (req.readyState == 4) {
                    if (req.status == 200) {
                        var config = JSON.parse(req.responseText);

                        fe.host = config['host'];
                        fe.port = config['port'];
                        fe.baseUrl = config['baseUrl'];
                        fe.logoutRedirect = config['logoutRedirect'];

                        promise.setSuccess();
                    } else {
                        promise.setError();
                    }
                }
            };

            req.send();

            return promise.promise;
        };

        /**
         *
         * @returns {{setSuccess: setSuccess, setError: setError, promise: {success: success, error: error}}}
         */
        function createPromise() {
            var p = {
                setSuccess: function (result) {
                    p.success = true;
                    p.result = result;
                    if (p.successCallback) {
                        p.successCallback(result);
                    }
                },

                setError: function (result) {
                    p.error = true;
                    p.result = result;
                    if (p.errorCallback) {
                        p.errorCallback(result);
                    }
                },

                promise: {
                    success: function (callback) {
                        if (p.success) {
                            callback(p.result);
                        } else if (!p.error) {
                            p.successCallback = callback;
                        }
                        return p.promise;
                    },
                    error: function (callback) {
                        if (p.error) {
                            callback(p.result);
                        } else if (!p.success) {
                            p.errorCallback = callback;
                        }
                        return p.promise;
                    }
                }
            };

            return p;
        };

    }

    if ( typeof module === "object" && module && typeof module.exports === "object" ) {
        module.exports = FrontEndProperties;
    } else {
        window.FrontEndProperties = FrontEndProperties;

        if ( typeof define === "function" && define.amd ) {
            define( "FrontEndProperties", [], function () { return FrontEndProperties; } );
        }
    }
})( window );
